import styled from 'styled-components'

export const BlogItem = styled.div`
margin-bottom: 20px;
position: relative;
border: 1px solid #e5e5e5;
img{
    width: 100%;
    height: 180px;
}
hr{
    margin: 7px 0px;
}
>a{
    font-size: 16px;
    font-weight: 700;
    margin-left: 14px;
    padding: 13px 2px;
    display: inline-block;
    color: black;
    :hover{
        text-decoration:underline;
        color: var(--primaryColor);
    }
}
`;

export const BlogItemText = styled.div`
padding: 10px 14px;
p{
    font-size: 12px;
    margin-top: 11px;
}
a{
    padding: 7px 14px;
    background-color: var(--primaryColor);
    display: inline-block;
    border-radius: 19px;
    color: white !important;
    font-weight: 600;
    font-size: 14px;
    margin-top: 10px;
    width: 100%;
    text-align: center;
}
`;
export const Info = styled.div`
display: flex;
justify-content: space-between;
border-bottom: 1px solid #e7e7e7;
border-top: 1px solid #e7e7e7;
padding: 10px 14px;
>div{
    i{
        font-size: 12px;
        margin-right: 6px;
        color: var(--primaryColor);
    }
    span{
        font-size: 12px;
        color: black;
    }
}
`;